import $ from "jquery";
import Vue from "vue";
import Data from "../application/Data";
import DataUtils from "./DataUtils";
import FiltersUtils from "./FiltersUtils";
import Utils from "./Utils";

export default class URLManager {
    public static data: any;
    public static previousHash: string;
    public static hash: string;
    public static params: string;
    private static hashChangeDelay: number = 200;

    public static paused: boolean = false;
    public static status: boolean = false;



    /**
     * The `init` function in TypeScript initializes data based on URL parameters for a catalog app,
     * setting the country and language if specified in the URL hash.
     * @returns If the condition `!Data.data.platform.useURL` is met, the function will return without
     * making any changes to the data object. If the hash is empty or not present in the URL, the
     * function will also return without making any changes.
     */
    public static init() {
        this.data = { app: "catalog", country: Data.data.country, language: Data.data.language };

        if (!Data.data.platform.useURL) return;

        let hash: string = window.location.hash;

        if (!hash) return;
        hash = hash.replace("#/", "");

        if (!hash || hash == "") return;


        //PUBLIC COUNTRY AND LANGUAGE
        if (Data.data.platform.id == "PUBLIC") {
            let tab: any = hash.split("/");
            let params: any = tab[0].split("-");
            if (params.length == 2) {
                if (Data.data.config.countries.indexOf(params[0]) != -1) {
                    this.data.country = params[0];
                    this.data.urlLanguage = params[1];
                    this.data.language = Data.data.config.countriesLanguages[this.data.country][0];
                }
            }
        }
    }
    /**
     * The function `startDetectURLChange` sets up an event listener for hash changes in the URL to
     * update data based on the URL.
     * @returns If the `useURL` property in the `Data.data.platform` object is `false`, the function
     * will return early and not execute the rest of the code.
     */
    public static startDetectURLChange() {
        if (!Data.data.platform.useURL) return;

        this.status = true;

        $(window).on("hashchange", this.setDataFromURL.bind(this));
    }
    /**
     * The function `stopDetectURLChange` disables URL change detection if the platform is configured
     * to use URLs.
     * @returns The `stopDetectURLChange` function will return nothing (`undefined`) as it is a void
     * function.
     */
    public static stopDetectURLChange() {
        if (!Data.data.platform.useURL) return;

        this.status = false;

        $(window).off("hashchange");
    }
    /**
     * The function `formatStringToUrl` takes a string input, converts it to lowercase, and removes any
     * non-alphanumeric characters to format it as a URL-friendly string.
     * @param {string} value - The `formatStringToUrl` function takes a string value as input and
     * converts it to a URL-friendly format. It converts the string to lowercase and removes any
     * characters that are not alphanumeric (letters or numbers).
     * @returns The `formatStringToUrl` function returns the input string `value` after converting it
     * to lowercase and removing any characters that are not alphanumeric (letters or numbers).
     */
    private static formatStringToUrl(value: string) {
        if (!value) return value;

        value = value.toLowerCase();
        return value.replace(/[^a-zA-Z0-9]/g, '');
    }
    public static setHash(hash: string, replace: boolean = false) {
        //window.history.pushState(null, null, "#/" + hash);
        //
        if (!replace) window.location.hash = "#/" + hash;
        //if (!replace) window.location.hash = "#/" + hash;
        //if (!replace) window.history.pushState(null, null, "#/" + hash);

        //@ts-ignore
        else window.history.replaceState(null, null, "#/" + hash);

        this.previousHash = hash;
    }
    /**
     * The `openHome` function in TypeScript switches the view to the home section and resets the user
     * path.
     * @returns If the `Data.data.section` is equal to "home", then the function `openHome()` will
     * return without making any further changes.
     */
    private static openHome() {
        if (Data.data.product) $(window).trigger("CLOSE_PRODUCT");

        if (Data.data.section == "home") return;

        console.log("openHome");

        Data.data.section = "home";
        Data.data.view = Data.data.platform.view;
        Data.data.userPath = [];
    }
    /**
     * The function `openView` in TypeScript updates the view and triggers a close event if a product
     * is open.
     * @param {string} view - The `view` parameter in the `openView` function represents the name or
     * identifier of the view that you want to open or switch to.
     * @returns If the `view` parameter is equal to `Data.data.view`, the function will return without
     * performing any further actions.
     */
    private static openView(view: string) {
        if (Data.data.product) $(window).trigger("CLOSE_PRODUCT");

        if (view == Data.data.view) return;

        console.log("openView", view);

        Data.data.view = view;
        //Data.data.section = view;

        //Data.data.product = null;
        //@ts-ignore
        FiltersUtils.setFilters();
    }
    /**
     * The function `openProduct` takes a product as a parameter and triggers an event to open the
     * product.
     * @param {any} product - The `product` parameter in the `openProduct` function is of type `any`,
     * which means it can accept any data type. It is used as an argument when triggering the
     * "OPEN_PRODUCT" event on the window object.
     */
    private static openProduct(product: any) {
        //Data.data.section = "product";
        $(window).trigger("OPEN_PRODUCT", product);
    }
    /**
     * The `resume` function sets the `paused` property to false.
     */
    private static resume() {
        this.paused = false;
    }







    /**
     * The function `setDataFromURL` in TypeScript parses data from the URL and updates the application
     * state accordingly.
     * @returns The `setDataFromURL` function returns nothing explicitly. It performs a series of
     * operations based on conditions and input data, but it does not have a return statement that
     * explicitly returns a value.
     */
    public static setDataFromURL() {
        if (!Data.data.platform.useURL || this.paused == true) return;

        this.paused = true;
        setTimeout(this.resume.bind(this), this.hashChangeDelay);

        this.hash = window.location.hash;

        if (!this.hash || this.hash == "") {
            this.openHome();
        }

        this.hash = this.hash.replace("#/", "");
        let tab: any = this.hash.split("?");
        this.hash = tab[0];
        this.params = tab[1];

        if (this.hash == "") {
            if (Data.data.platform.id == "MYVERALLIA") {
                Data.data.products = Data.productsJson;
                Data.data.baseProducts = Data.baseProductsJson;
                this.openView("general");
            } else {
                this.openHome();
            }

            return;
        }

        tab = this.hash.split("/");
        if (tab.length == 0) {
            if (Data.data.platform.id == "MYVERALLIA") {
                Data.data.products = Data.productsJson;
                Data.data.baseProducts = Data.baseProductsJson;
                this.openView("general");
            } else {
                this.openHome();
            }

            return;
        }


        if (Data.data.app == "catalog") {
            if (Data.data.platform.id == "INTERNAL" || Data.data.platform.id == "MYVERALLIA" || Data.data.platform.id == "SELECTIVELINE" || Data.data.platform.id == "PUBLIC") {
                let view: string = tab[0];
                let bp: string = tab[1];

                if (Data.data.platform.id == "SELECTIVELINE") {
                    view = "slproducts";
                } else if (Data.data.platform.id == "PUBLIC") {
                    view = "publicproducts";
                }

                //if (Data.data.platform.id == "SELECTIVELINE")

                if (view && view.charAt(0) == "8") {

                } else {
                    if (!Data.data.config.views[Data.data.platform.view]) return;
                    if (Data.data.config.views[Data.data.platform.view].views.indexOf(view) == -1) return;

                    if (Data.data.platform.id == "MYVERALLIA") {
                        if (view == "myproducts") {
                            Data.data.products = Data.myProductsJson;
                            Data.data.baseProducts = Data.myProductsBaseProductsJson;
                        } else {
                            Data.data.products = Data.productsJson;
                            Data.data.baseProducts = Data.baseProductsJson;
                        }
                    }

                    this.openView(view);

                    if (bp && bp.charAt(0) == "8") {
                        let str: string;
                        let found: boolean = false;
                        for (str in Data.data.products) {
                            let bpIndex: number = Data.data.products[str].baseProducts.indexOf(bp);
                            if (bpIndex != -1) {
                                Data.data.products[str].bpIndex = bpIndex;

                                this.openProduct(Data.data.products[str]);
                                found = true;

                                break;
                            }
                        }

                        if (!found && Data.data.product) Data.data.product = null;
                    }
                }
            }

            //FILTERS
            if (Data.data.platform.catalogFiltersInURL == true && Data.data.view && Data.data.config.views[Data.data.view].filters && this.params) {
                let p: any = Utils.copy(this.params);
                this.setFiltersFromURLParams(p);
                //setTimeout(this.setFiltersFromURLParams.bind(this, p), 100);
            }
        }

        this.setURLFromData(true);
    }
    /**
     * The function `setFiltersFromURLParams` parses URL parameters and updates filters based on the
     * configuration and values provided.
     * @param {string} URLparams - The `setFiltersFromURLParams` function takes a string `URLparams` as
     * a parameter. This string contains URL parameters that are used to set filters in the application
     * based on the provided values. The function parses these URL parameters and updates the filters
     * accordingly.
     */
    private static setFiltersFromURLParams(URLparams: string) {
        let filters: any = FiltersUtils.createFilters(Data.data.view);

        if (URLparams) {
            let URLParams: any = URLparams.split("&");
            let params: any = {};
            let a: number = URLParams.length;
            for (let i = 0; i < a; i++) {
                let tab: any = URLParams[i].split("=");
                params[tab[0]] = tab[1];
            }

            let str: string;
            for (str in params) {
                let paramData: any = params[str];
                let filterConfig: any = Data.data.config.filters[str];

                if (filterConfig && params) {
                    if (Data.data.config.views[Data.data.view].filters.indexOf(str) != -1) {

                        //VALUE
                        if (filterConfig.type == "value") {
                            if (paramData == "true") filters[str] = true;

                            //MULTIPLE VALUES
                        } else if (filterConfig.type == "multipleValues") {
                            let a: number = Data.data.filters[str].data.length;
                            paramData = paramData.split(",");

                            for (let i = 0; i < a; i++) {
                                let value: string = this.formatStringToUrl(Data.data.filters[str].data[i].toLowerCase());
                                if (paramData.indexOf(value) != -1) filters[str].selected.push(Data.data.filters[str].data[i]);
                            }

                            //ARRAY
                        } else if (filterConfig.type == "array") {
                            let a: number = Data.data.filters[str].length;
                            paramData = paramData.split(",");

                            for (let i = 0; i < a; i++) {
                                if (paramData.indexOf(filters[str][i].id) != -1) filters[str][i].selected = true;
                            }

                            //TREE VALUES
                        } else if (filterConfig.type == "treeValues") {
                            paramData = paramData.split("-");
                            let paramsList: any = {};

                            let a: number = paramData.length;
                            for (let i = 0; i < a; i++) {
                                let tab: any = paramData[i].split("_");
                                paramsList[tab[0]] = [];
                                if (tab[1]) paramsList[tab[0]] = tab[1].split(",");
                            }

                            //console.log(paramsList);

                            a = Data.data.filters[str].length;
                            for (let i = 0; i < a; i++) {
                                if (paramsList[filters[str][i].id]) {
                                    filters[str][i].selected = true;

                                    let b: number = filters[str][i].sub.length;
                                    for (let j = 0; j < b; j++) {
                                        if (paramsList[filters[str][i].id].indexOf(filters[str][i].sub[j].id) != -1) {
                                            filters[str][i].sub[j].selected = true;
                                        }
                                    }
                                }
                            }

                            //NUMBER RANGE
                        } else if (filterConfig.type == "numberRange") {
                            let a: number = Data.data.filters[str].length;
                            paramData = paramData.split("-");

                            if (Number(paramData[0]) < Number(paramData[1]) && Number(paramData[0]) >= filters[str].min && Number(paramData[1]) <= filters[str].max) {
                                filters[str].range[0] = Number(paramData[0]);
                                filters[str].range[1] = Number(paramData[1]);
                            }

                            //DATES RANGE
                        } else if (filterConfig.type == "datesRange") {
                            let a: number = Data.data.filters[str].length;
                            paramData = paramData.split("-");

                            let startIndex: number = filters[str].dates.indexOf(paramData[0]);
                            let endIndex: number = filters[str].dates.indexOf(paramData[1]);

                            if (startIndex != -1 && endIndex != -1 && startIndex <= endIndex && startIndex >= 0 && endIndex <= filters[str].dates.length - 1) {
                                filters[str].startDate = paramData[0];
                                filters[str].endDate = paramData[1];
                            }
                        }
                    }
                }
            }
        }

        if (JSON.stringify(Data.data.filters) != JSON.stringify(filters)) {
            Data.data.savedFilters[Data.data.platform.id + "-" + Data.data.view] = filters;
            Data.data.filters = filters;

            $(window).trigger("UPDATE_FILTERS");
        }
    }
    /**
     * The function `setURLFromData` in TypeScript constructs a URL based on certain data parameters
     * and filters, with options to force an update and replace the current URL.
     * @param {boolean} [force=false] - The `force` parameter in the `setURLFromData` function is a
     * boolean parameter that determines whether to force the URL update. If `force` is set to `true`,
     * the URL update will be forced regardless of other conditions. If `force` is set to `false`
     * (default
     * @param {boolean} [replaceURL=false] - The `replaceURL` parameter in the `setURLFromData`
     * function is a boolean parameter that determines whether the URL should be replaced with the new
     * hash value or not. If `replaceURL` is set to `true`, the new hash value will replace the
     * existing URL in the browser's address
     * @returns The `setURLFromData` function is not returning any value. It is a method that performs
     * certain operations based on the conditions and parameters provided, but it does not have a
     * return statement to return any specific value.
     */
    public static setURLFromData(force: boolean = false, replaceURL: boolean = false) {
        if (force == false) {
            if (!Data.data.platform.useURL) return;

            if (this.paused == true) return;
        }

        this.paused = true;
        setTimeout(this.resume.bind(this), this.hashChangeDelay);

        let hash: string = "";
        let params: string = "";

        if (Data.data.app == "catalog") {
            if (Data.data.platform.id == "INTERNAL") {
                if (Data.data.view) hash += this.formatStringToUrl(Data.data.view);
                if (Data.data.product) hash += "/" + Data.data.product.baseProducts[Data.data.product.bpIndex] + "/" + this.formatStringToUrl(Data.data.product.name);

            } else if (Data.data.platform.id == "MYVERALLIA") {
                if (Data.data.view && Data.data.section != "home") hash += this.formatStringToUrl(Data.data.view);
                if (Data.data.product) hash += "/" + Data.data.product.baseProducts[Data.data.product.bpIndex] + "/" + this.formatStringToUrl(Data.data.product.name);

            } else if (Data.data.platform.id == "PUBLIC") {
                if (!Data.data.product) hash += Data.data.country + "-" + Data.data.language;
                else hash += Data.data.country + "-" + Data.data.language + "/" + Data.data.product.baseProducts[Data.data.product.bpIndex] + "/" + this.formatStringToUrl(Data.data.product.name);
            } else if (Data.data.platform.id == "SELECTIVELINE") {
                if (!Data.data.product) hash += Data.data.language;
                else hash += Data.data.language + "/" + Data.data.product.baseProducts[Data.data.product.bpIndex] + "/" + this.formatStringToUrl(Data.data.product.name);
            }

            //FILTERS
            if (Data.data.platform.catalogFiltersInURL == true && Data.data.section == "view" && Data.data.view && Data.data.config.views[Data.data.view].filters) {
                let a: number = Data.data.config.views[Data.data.view].filters.length;
                for (let i = 0; i < a; i++) {
                    let f: string = Data.data.config.views[Data.data.view].filters[i];
                    let filterConfig: any = Data.data.config.filters[f];

                    if (!filterConfig || !Data.data.filters || !Data.data.filters[f]) continue;


                    //VALUE
                    if (filterConfig.type == "value") {
                        if (Data.data.filters[f] == true) params += "&" + f + "=true";

                        //MULTIPLE VALUES
                    } else if (filterConfig.type == "multipleValues") {
                        let multipleValues: string = "&" + f + "=";

                        let b: number = Data.data.filters[f].selected.length
                        if (b == 0) continue;

                        for (let j = 0; j < b; j++) {
                            multipleValues += this.formatStringToUrl(Data.data.filters[f].selected[j].toLowerCase()) + ",";
                        }

                        params += multipleValues.slice(0, -1);

                        //ARRAY
                    } else if (filterConfig.type == "array") {
                        let arrayValues: string = "&" + f + "=";

                        let c: number = 0;
                        let b: number = Data.data.filters[f].length;
                        for (let j = 0; j < b; j++) {
                            if (Data.data.filters[f][j].selected == true) {
                                arrayValues += Data.data.filters[f][j].id + ",";
                                c++;
                            }
                        }

                        if (c != 0 && c != b) params += arrayValues.slice(0, -1);

                        //TREE VALUES
                    } else if (filterConfig.type == "treeValues") {
                        let treeValues: string = "&" + f + "=";

                        let c: number = 0;
                        let b: number = Data.data.filters[f].length;
                        for (let j = 0; j < b; j++) {
                            if (Data.data.filters[f][j].selected == true) {
                                if (c == 0) treeValues += Data.data.filters[f][j].id;
                                else treeValues += "-" + Data.data.filters[f][j].id;
                                c++;

                                let subtreeValues: string = "_";

                                let d: number = Data.data.filters[f][j].sub.length;
                                for (let k = 0; k < d; k++) {
                                    if (Data.data.filters[f][j].sub[k].selected == true) {
                                        subtreeValues += Data.data.filters[f][j].sub[k].id + ",";
                                    }
                                }

                                if (subtreeValues != "_") treeValues += subtreeValues.slice(0, -1);
                            }
                        }

                        if (c != 0) params += treeValues;

                        //NUMBER RANGE
                    } else if (filterConfig.type == "numberRange") {
                        let numberValues: string = "&" + f + "=";

                        if (Data.data.filters[f].range[0] > Data.data.filters[f].min || Data.data.filters[f].range[1] < Data.data.filters[f].max) {
                            params += numberValues + Data.data.filters[f].range[0] + "-" + Data.data.filters[f].range[1];
                        }

                        //DATES RANGE
                    } else if (filterConfig.type == "datesRange") {
                        let datesValues: string = "&" + f + "=";

                        if (Data.data.filters[f].startDate != Data.data.filters[f].dates[0] || Data.data.filters[f].endDate != Data.data.filters[f].dates[Data.data.filters[f].dates.length - 1]) {
                            params += datesValues + Data.data.filters[f].startDate + "-" + Data.data.filters[f].endDate;
                        }
                    }
                }

                if (params != "") params = "?" + params.substring(1);
            }
        }

        if (this.previousHash != hash + params) this.setHash(hash + params, replaceURL);
    }
}